import ReactMarkdown from 'react-markdown';
import getSafe from '../utils/getSafe';
import { Typography } from '@mui/material';
import remarkGfm from "remark-gfm";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

const NotesDisplay = ({ appConfig, insurerId }) => {

  const notes = getSafe(() => appConfig.content.specifics[insurerId].notes, '');

  return (
    <div>
      {
        notes &&
        <Typography sx={{ mt: 2, fontSize: 14 }}>
          <b>Notes:</b>
          <ReactMarkdown
            remarkPlugins={[remarkGfm]}
            components={{
              table: ({ node, ...props }) => <Table size="small" sx={{ width: 'auto' }} {...props} />,
              thead: ({ node, ...props }) => <TableHead {...props} />,
              tbody: ({ node, ...props }) => <TableBody {...props} />,
              tr: ({ node, ...props }) => <TableRow {...props} />,
              th: ({ node, ...props }) => (
                <TableCell {...props} />
              ),
              td: ({ node, ...props }) => <TableCell {...props} />,
              a: ({ node, ...props }) => (
                <a {...props} target="_blank" rel="noopener noreferrer" />
              ),
            }}
          >{notes}</ReactMarkdown>
        </Typography>
      }
    </div>
  );
};

export default NotesDisplay;